import { captureEvent } from "@sentry/react";
import type { IOption } from "@src/components/ui-kit/Select";
import { observer } from "mobx-react-lite";
import { AutocompleteField, type AutocompleteFieldProps } from "../..";

interface DocumentSequenceAutocompleteFieldProps
  extends Omit<AutocompleteFieldProps, "loading" | "charCount" | "onSelect"> {
  isLoading?: boolean;
  onSelect: (option: IOption) => void;
}
export const DocumentSequenceAutocompleteField = observer(
  function InvoiceSequenceAutocompleteField({
    isLoading = false,
    ...props
  }: DocumentSequenceAutocompleteFieldProps) {
    return (
      <AutocompleteField
        {...props}
        charCount={0}
        showPopoverTrigger
        loading={isLoading}
        onSelect={(option) => {
          if (typeof option.label !== "string") {
            captureEvent({
              message: "FE: Bad label type",
            });
            return;
          }
          props.onSelect({
            label: option.label,
            value: option.value,
          });
        }}
      />
    );
  },
);
